
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

interface MobileNavigationProps {
  isOpen: boolean;
  onClose: () => void;
}

export function MobileNavigation({ isOpen, onClose }: MobileNavigationProps) {
  const { user, signOut, isAdmin } = useAuth();

  const handleSignOut = async () => {
    await signOut();
    onClose();
  };

  const getDashboardUrl = () => {
    return isAdmin ? "/logins?admin=true" : "/meus-dados";
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 bg-white flex flex-col items-center justify-center gap-8 text-2xl font-bold md:hidden">
      <Link to="/sobre" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
        Quem Somos
      </Link>
      <Link to="/servicos" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
        Serviços
      </Link>
      <Link to="/avaliacoes" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
        Agendamento
      </Link>
      <Link to="/consultorios" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
        Depoimentos
      </Link>
      <span className="text-gray-300 cursor-not-allowed">
        Loja
      </span>
      <span className="text-gray-300 cursor-not-allowed">
        Blog
      </span>
      <Link to="/contato" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
        Contato
      </Link>
      {user ? (
        <div className="flex flex-col items-center gap-4">
          <Link to={getDashboardUrl()} onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
            Painel
          </Link>
          <Link to="/meus-dados" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
            Meus Dados
          </Link>
          <Link to="/preferencias" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
            Preferências
          </Link>
          <button onClick={handleSignOut} className="text-brand-primary hover:text-brand-secondary transition-colors">
            Sair
          </button>
        </div>
      ) : (
        <Link to="/logins" onClick={onClose} className="text-brand-primary hover:text-brand-secondary transition-colors">
          Área do Paciente
        </Link>
      )}
      <a
        href="https://wa.me/5511998874081"
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClose}
        className="bg-brand-primary text-white px-8 py-3 rounded-full hover:opacity-90 transition-all"
      >
        Agendar Consulta
      </a>
    </div>
  );
}
